import { combineReducers } from 'redux';
import navigationReducer from './navigationReducer';
import pageReducer from './pageReducer';
import apartmentsReducer from './apartmentsReducer';
import apartmentReducer from './apartmentReducer';
import themeReducer from './themeReducer';
import articlesReducer from './articlesReducer';
import modalReducer from './modalReducer';
import cookieReducer from './cookieReducer';
import pageSettingsReducer from './pageSettingsReducer';
import filtersReducer from './filtersReducer';
import contextMenuReducer from './contextMenuReducer';
import applicationReducer from './applicationReducer';
import authReducer from './authReducer';

export default combineReducers({
	navigationReducer,
	pageReducer,
	apartmentsReducer,
	apartmentReducer,
	themeReducer,
	articlesReducer,
	modalReducer,
	cookieReducer,
	pageSettingsReducer,
	filtersReducer,
	contextMenuReducer,
	applicationReducer,
	authReducer
});
